import { SuccessfulAuth } from "../../auth/authSlice";
import authParams from "../params";
import { authenticationClient } from "../clients";
import { Auth0Error, Auth0Result } from "auth0-js";
import { getUserInfo } from "./getUserInfo";

const refreshCredentials = (refreshToken: string): Promise<SuccessfulAuth> =>
  new Promise((resolve, reject) => {
    authenticationClient.oauthToken(
      {
        grantType: "refresh_token",
        clientId: authParams.client_id,
        refreshToken: refreshToken,
      },
      async (error: Auth0Error | null, result: Auth0Result) => {
        // Reject with Auth0's error so the caller can tell a refused refresh
        // token (log out) from a network problem (keep the session).
        if (error || !result) {
          return reject(error);
        }

        const { accessToken, idToken, refreshToken, expiresIn } = result;
        if (!accessToken || !idToken || !refreshToken || !expiresIn) {
          const error: Auth0Error = {
            error: "Invalid credentials were received",
          };
          return reject(error);
        }

        const auth = await getUserInfo({
          accessToken,
          idToken,
          refreshToken,
          expiresIn,
        });

        resolve(auth);
      },
    );
  });

export { refreshCredentials };
